import React from 'react';
import { Card, Button, Typography } from 'antd';
import { UploadOutlined, FileSearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { NimbusLogo } from './NimbusLogo';
import './FileUpload.css';

const { Title, Text } = Typography;

export const NoDataVisualization: React.FC = () => {
  const navigate = useNavigate();

  const handleNewUpload = () => {
    navigate('/');
  };

  return (
    <div className="file-upload-container">
      <Card 
        title={
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <NimbusLogo className="no-data-logo" />
          </div>
        }
        className="file-upload-card"
      >
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
          padding: '40px 20px',
          textAlign: 'center'
        }}>
          <FileSearchOutlined 
            style={{ 
              fontSize: '64px', 
              color: '#d9d9d9',
              marginBottom: '24px'
            }} 
          />
          
          <Title level={3} style={{ color: '#595959', marginBottom: '12px' }}>
            Oops! We couldn't find your data
          </Title>
          
          <Text 
            type="secondary" 
            style={{ 
              fontSize: '14px', 
              marginBottom: '32px',
              maxWidth: '400px',
              lineHeight: '1.6'
            }}
          >
            It looks like the analysis data you're looking for isn't available right now. 
            This might happen if the processing is still in progress or if there was an issue with the original upload.
          </Text>

          <Button 
            type="primary" 
            size="large"
            icon={<UploadOutlined />}
            onClick={handleNewUpload}
            style={{
              height: '48px',
              padding: '0 32px',
              fontSize: '16px'
            }}
          >
            Start New Upload
          </Button>
        </div>
      </Card>
    </div>
  );
};